import React from 'react';
import { Box, TextButton, Text } from '@wix/design-system';
import { DomainSearchSuiteModule } from '../../../../../domainSearchSuite.module';
import { parseDomain } from '@wix/domains-serverless-interface';
export const SubdomainRootIsTaken = _ref => {
  let domainName = _ref.domainName,
    action = _ref.action,
    datahook = _ref.datahook;
  const parsedDomain = parseDomain(domainName ?? '');
  const _parseDomain = parseDomain(parsedDomain.main),
    formattedInput = _parseDomain.formattedInput;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    Trans = _DomainSearchSuiteMod.Trans;
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    marginTop: "SP4",
    textAlign: "center",
    dataHook: datahook
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.subdomain",
    values: {
      domainName: formattedInput
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "normal",
      onClick: action
    })]
  })));
};
//# sourceMappingURL=SubdomainRootIsTaken.js.map